export var LOGIC_OPTIONS = {
  date: [{
    label: "Select",
    value: ""
  }, {
    label: "After",
    value: "gt"
  }, {
    label: "Before",
    value: "lt"
  }, {
    label: "On",
    value: "exact"
  }, {
    label: "Between",
    value: "between"
  }],
  number: [{
    label: "Select operator...",
    value: ""
  }, {
    label: "Greater than",
    value: "gt"
  }, {
    label: "Less than",
    value: "lt"
  }, {
    label: "Greater than or equal to",
    value: "gte"
  }, {
    label: "Less than or equal to",
    value: "lte"
  }, {
    label: "Exact",
    value: "exact"
  }]
};
export var LOGIC_SYMBOLS = {
  date: {
    gt: "After ",
    gte: "On or after ",
    lt: "Before ",
    lte: "On or before ",
    exact: "On ",
    between: "Between "
  },
  number: {
    gt: "> ",
    lt: "< ",
    gte: "≥ ",
    lte: "≤ ",
    exact: "= "
  }
};
export var getLogicSymbol = function getLogicSymbol(logic, tagType) {
  if (tagType === "date") {
    return LOGIC_SYMBOLS.date[logic] || "";
  } else {
    return LOGIC_SYMBOLS.number[logic] || "";
  }
};
export var getLogicOptions = function getLogicOptions(tagType) {
  if (tagType === "date") {
    return LOGIC_OPTIONS.date;
  } else {
    return LOGIC_OPTIONS.number;
  }
};